var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stroop-wrapper"},_vm._l((_vm.items),function(item){return _c('span',{staticClass:"stroop-word",style:({ 'color': item.color })},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }